import { render, staticRenderFns } from "./RegisterContentCmp.vue?vue&type=template&id=42c197d4&"
import script from "./RegisterContentCmp.vue?vue&type=script&lang=js&"
export * from "./RegisterContentCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports